import React, { useEffect } from 'react';
import { useLottie } from 'lottie-react';

import type { LottieComponentProps } from 'lottie-react';

interface MochiLottieProps {
  animationData: LottieComponentProps['animationData'];
  loop?: LottieComponentProps['loop'];
  style?: LottieComponentProps['style'];
  className?: LottieComponentProps['className'];
  stopped?: boolean;
}

const MochiLottie = React.forwardRef<HTMLDivElement, MochiLottieProps>(
  ({ stopped, ...props }: MochiLottieProps, ref) => {
    const { View, play, pause } = useLottie(
      {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        lottieRef: ref,
        autoPlay: true,
        loop: props.loop,
        animationData: props.animationData,
        className: props.className,
      },
      props.style,
    );

    useEffect(() => {
      if (typeof stopped !== 'boolean') return;

      if (stopped) pause();
      else play();
    }, [stopped, play, pause]);

    return View;
  },
);

MochiLottie.displayName = 'MochiLottie';

export { MochiLottie };
export type { MochiLottieProps };
